import { IGiftCardInfoForm } from '@app/checkout/guest-details/gift-card-form/gift-card-info-form.model';
import { IDictionary } from '@app/core/common.model';

/**
 * Roller.Core.Domain.DTO.API.APIUserDTO.
 * Used throughout the app as general customer details.
 * BasicCustomerDTO may be mapped to update this model
 */
export interface IUserAPI {
  email: string;
  firstName: string;
  lastName: string;
  phone?: string;
  callingCode?: number;
  address?: string;
  country?: string;
  state?: string;
  postCode?: string;
  suburb?: string;
  acceptMarketing?: boolean;
  /** Internal use only - Populate information for gift cards and membership subscription terms. */
  ticketUserInfo?: IGiftCardInfoForm[];
  subscriptionTerms?: IDictionary<boolean>;
  ticketHolders?: IDictionary<string>;
  /** From IBasicCustomer - include this as part of guestAccount storage */
  customerId?: number;
  isTermsAccepted?: boolean;
}

export function blankUserAPI(): IUserAPI {
  return {
    email: '',
    firstName: '',
    lastName: ''
  };
}
